import {BibMotivoDispensaMultaModel} from '@/models/biblioteca/bibmotivodispensamulta/bibmotivodispensamulta.model';
import api from '@/services/axios/api';
import {AxiosResponse} from 'axios';
import {DataSource, FiltrosModel} from '@/datasources/consulte-grid';
import TextoValor from '@/models/texto-valor';
import {RegisterOutput} from '@/models/register-output';

class BibMotivoDispensaMultaService {
 dadosIndexPaginado(pagina: number, itensPorPagina: number, filters: FiltrosModel[]): Promise<AxiosResponse<DataSource<BibMotivoDispensaMultaModel>>> {
  return api.post <DataSource <BibMotivoDispensaMultaModel>>('/BibMotivoDispensaMulta/RetornoPaginado', {
   rowsPerPage:  itensPorPagina,
   pageNumber: pagina,
   filters: filters
  });
 }

 inserirAtualizar(bibMotivoDispensaMulta: BibMotivoDispensaMultaModel): Promise<AxiosResponse<RegisterOutput>> {
  const result = api.post('/BibMotivoDispensaMulta', bibMotivoDispensaMulta);
  return result;
 }

 remover(id: number): Promise<AxiosResponse> {
  return api.delete('/BibMotivoDispensaMulta/' + id);
 }

 atualizar(bibMotivoDispensaMulta: BibMotivoDispensaMultaModel): Promise<AxiosResponse> {
  return api.put('/BibMotivoDispensaMulta', bibMotivoDispensaMulta);
 }

 async get(id: number): Promise<BibMotivoDispensaMultaModel> {
  const result = await api.get<BibMotivoDispensaMultaModel>(`/BibMotivoDispensaMulta/${id.toString()}`);
  return result.data;
 }
  async DropDownList() : Promise<TextoValor[]> {
  const endpoint = "/BibMotivoDispensaMulta/DropDownList";
  const result = await api.get(endpoint);
  // Mapeando os dados para o formato TextoValor
  return result.data.map((item: any) => ({
   valor: item.valor,
   texto: item.texto,
   }));
 }

}
export default new BibMotivoDispensaMultaService();

